module.exports = __webpack_public_path__ + "static/media/flu.68071128.svg";